import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const COLORS = ['#0e487a', '#86bddc', '#d16265', '#e9c31a', '#16a34a', '#9333ea'];

export default function Folders() {
  const { api } = useAuth();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [color, setColor] = useState(COLORS[0]);
  const [editing, setEditing] = useState(null);

  const load = () => api('/folders').then(setItems).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async () => {
    if (!name.trim()) return;
    try {
      if (editing) await api(`/folders/${editing.id}`, { method: 'PUT', body: JSON.stringify({ name, color }) });
      else         await api('/folders',                 { method: 'POST', body: JSON.stringify({ name, color }) });
      setName(''); setEditing(null); load();
      toast.success('تم الحفظ');
    } catch (e) { toast.error(e.message); }
  };

  const remove = async (id) => {
    if (!window.confirm('حذف هذا المجلّد؟ التفريغات بداخله ستفقد الانتماء للمجلّد لكنها لن تُحذف.')) return;
    try { await api(`/folders/${id}`, { method: 'DELETE' }); load(); toast.success('تم الحذف'); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>📂 المجلّدات</h2>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">{editing ? 'تعديل مجلّد' : 'مجلّد جديد'}</div>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          <input className="form-input" placeholder="اسم المجلّد" value={name} onChange={e => setName(e.target.value)} style={{ flex: 1, minWidth: 200 }}/>
          <div style={{ display: 'flex', gap: 4 }}>
            {COLORS.map(c => (
              <button key={c} onClick={() => setColor(c)} style={{ width: 28, height: 28, borderRadius: '50%', border: color === c ? '3px solid var(--text)' : '1px solid var(--border)', background: c, cursor: 'pointer' }} aria-label={c} type="button" />
            ))}
          </div>
          <button className="btn btn-primary" onClick={save}>{editing ? 'حفظ' : 'إضافة'}</button>
          {editing && <button className="btn btn-outline" onClick={() => { setEditing(null); setName(''); }}>إلغاء</button>}
        </div>
      </div>

      <div className="card">
        <div className="card-title" style={{ marginBottom: 12 }}>{items.length} مجلّد</div>
        {items.length === 0 ? (
          <div className="empty">لا مجلّدات بعد</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
            {items.map(f => (
              <div key={f.id} style={{ padding: 12, borderRadius: 8, border: `2px solid ${f.color || 'var(--border)'}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{f.name}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{f.transcriptions_count || 0} تفريغ</div>
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button className="btn btn-sm btn-outline" onClick={() => { setEditing(f); setName(f.name); setColor(f.color || COLORS[0]); }}>✏️</button>
                  <button className="btn btn-sm btn-outline" style={{ color: 'var(--danger)' }} onClick={() => remove(f.id)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
